<template>
  <fb-main-body>
    <el-form label-width="120px" style="width: 500px">
      <el-form-item :label="$t('lang.标题') + '：'">
        <el-input disabled v-model="detailInfo.title"></el-input>
      </el-form-item>
      <el-form-item :label="$t('lang.内容') + '：'">
        <el-input disabled v-model="detailInfo.content" type="textarea" :rows="5"></el-input>
      </el-form-item>

      <el-form-item :label="$t('lang.推送方式') + '：'">
        <span style="display: inline-block; width: 100px">{{ detailInfo['pushType'] | filterName(that) }}</span>
        <span style="color: #2f86dd;border-bottom: 1px solid #2f86dd;cursor: pointer" v-if="detailInfo['pushType'] == 'user'" @click="handleDownloadFile">推送名单Excel下载</span>
      </el-form-item>

      <el-form-item :label="$t('lang.推送时间') + '：'">
        <span style="display: inline-block; width: 100px">{{ detailInfo['pushMode'] == "immediate" ? $t('lang.即时发送') : $t('lang.定时发送') }}</span>
        <span v-if="detailInfo['pushMode'] == 'timer'">{{ detailInfo['pushTimeStr'] }}</span>
      </el-form-item>

    </el-form>



  </fb-main-body>
</template>

<script>
import {downloadFile} from "../../js/common";

export default {
  name: "Detail",
  data() {
    return {
      api: {
        detail: this.$api.inform.detail,
      },
      detailInfo: {},
      that: this,
    }
  },
  filters: {
    filterName(name, vm) {
      switch (name) {
        case "all":
          name = vm.$t('lang.全体发送');
          break;
        case "region":
          name = vm.$t('lang.限定地区');
          break;
        case "user":
          name = vm.$t('lang.自定义用户');
          break;
        case "product":
          name = vm.$t('lang.限定产品');
          break;
      }
      return name;
    }
  },
  methods: {
    handleDownloadFile() {
      downloadFile(this, this.detailInfo['fileCode']);
    },
    handleGetInfo() {
      const vm = this;
      vm.$http.post(vm.api.detail, this.$qs.stringify(this.$route.query)).then(res => {
        if(res.data.status != 200) {
          vm.$message.error(res.data.desc);
          return;
        }
        vm.detailInfo = res.data.data['inform'];

      })
    }
  },
  created() {
    this.handleGetInfo();
  }
}
</script>

<style scoped>

</style>
